
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/webcam",
      function () {
        return require("private-next-pages/[region]/[resort]/webcam.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/webcam"])
      });
    }
  